(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["add-to-cart"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__pnpAtcGuard) return;
  window.__pnpAtcGuard = true;
  var LOCK = 1500;
  var release = function (btn) {
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
  };
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button.add-to-cart-button') : null;
    if (!btn || btn.disabled) return;
    setTimeout(function () {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      setTimeout(function () { release(btn); }, LOCK);
    }, 0);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bundle-picker"] && !Shopify.designMode) return;
  try {
    class BundlePicker extends HTMLElement {
  connectedCallback() {
    this.addUrl = this.dataset.addUrl || '/cart/add';
    this.cartUrl = this.dataset.cartUrl || '/cart';
    this.afterAdd = this.dataset.afterAdd || 'cart';
    this.radios = Array.from(this.querySelectorAll('.bp__radio'));
    this.totalEl = this.querySelector('[data-bp-total]');
    this.errorEl = this.querySelector('[data-bp-error]');
    this.button = this.querySelector('[data-bp-add]');
    this.radios.forEach((r) => r.addEventListener('change', () => this.sync()));
    if (this.button) this.button.addEventListener('click', () => this.add());
    this.sync();
  }

  get tier() {
    const checked = this.radios.find((r) => r.checked) || this.radios[0];
    return checked ? checked.value : '1';
  }

  sync() {
    const tier = this.tier;
    this.querySelectorAll('.bp__opts').forEach((el) => {
      el.classList.toggle('is-open', el.dataset.optsFor === tier);
    });
    const price = this.querySelector('.bp__tier[data-tier="' + tier + '"] .bp__now');
    if (this.totalEl && price) this.totalEl.textContent = price.textContent.trim();
    this.clearError();
  }

  clearError() {
    if (!this.errorEl) return;
    this.errorEl.hidden = true;
    this.errorEl.textContent = '';
  }

  fail(message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message;
    this.errorEl.hidden = false;
  }

  async add() {
    const wrap = this.querySelector('.bp__opts[data-opts-for="' + this.tier + '"]');
    const fields = wrap ? Array.from(wrap.querySelectorAll('.bp__vid')) : [];
    const items = fields
      .map((f) => ({ id: Number(f.value), quantity: 1 }))
      .filter((i) => Number.isFinite(i.id) && i.id > 0);

    if (!items.length) {
      this.fail('Please choose an option before adding to cart.');
      return;
    }

    this.clearError();
    this.button.setAttribute('aria-busy', 'true');

    try {
      const res = await fetch(this.addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: items }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.description || data.message || 'That item could not be added.');

      if (this.afterAdd === 'checkout') {
        window.location.href = '/checkout';
        return;
      }
      if (this.afterAdd === 'drawer') {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        const opener = document.querySelector('[data-cart-drawer-trigger], .header__cart, a[href$="/cart"]');
        if (opener) {
          opener.click();
          this.button.removeAttribute('aria-busy');
          return;
        }
      }
      window.location.href = this.cartUrl;
    } catch (e) {
      this.fail(e.message);
      this.button.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('bundle-picker')) customElements.define('bundle-picker', BundlePicker);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["delivery-timeline"] && !Shopify.designMode) return;
  try {
    class DeliveryTimeline extends HTMLElement {
  connectedCallback() {
    const num = (key, fallback) => {
      const v = parseInt(this.dataset[key], 10);
      return Number.isFinite(v) ? v : fallback;
    };
    const readyMin = num('readyMin', 1);
    const readyMax = num('readyMax', 2);
    const deliverMin = num('deliverMin', 7);
    const deliverMax = num('deliverMax', 12);
    const today = new Date();

    const shift = (days) => {
      const d = new Date(today);
      d.setDate(d.getDate() + days);
      return d;
    };
    const fmt = (d) => d.toLocaleDateString(document.documentElement.lang || undefined, { month: 'short', day: 'numeric' });
    const range = (a, b) => (fmt(a) === fmt(b) ? fmt(a) : fmt(a) + ' - ' + fmt(b));

    const set = (key, text) => {
      const el = this.querySelector('[data-dtl="' + key + '"]');
      if (el) el.textContent = text;
    };

    set('ordered', fmt(today));
    set('ready', range(shift(readyMin), shift(readyMax)));
    set('delivered', range(shift(readyMin + deliverMin), shift(readyMax + deliverMax)));
  }
}

if (!customElements.get('delivery-timeline')) customElements.define('delivery-timeline', DeliveryTimeline);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sticky-atc"] && !Shopify.designMode) return;
  try {
    class StickyAtc extends HTMLElement {
  connectedCallback() {
    this.addUrl = this.dataset.addUrl || '/cart/add';
    this.cartUrl = this.dataset.cartUrl || '/cart';
    this.afterAdd = this.dataset.afterAdd || 'cart';
    this.button = this.querySelector('[data-sab-add]');
    if (this.button) this.button.addEventListener('click', () => this.add());
    this.watch();
    this.link();
  }

  link() {
    this.sel = this.querySelector('.sab__vid');
    if (!this.sel) return;
    this.pull();
    document.addEventListener('change', (e) => {
      if (e.target === this.sel) { this.push(); return; }
      setTimeout(() => this.pull(), 120);
    });
  }

  mainSelect() {
    return document.querySelector('select.variant-option__select');
  }

  pull() {
    const inp = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!inp || !inp.value || !this.sel) return;
    if (this.sel.value !== inp.value) this.sel.value = inp.value;
  }

  push() {
    const main = this.mainSelect();
    const opt = this.sel.options[this.sel.selectedIndex];
    if (!main || !opt) return;
    main.value = opt.textContent.trim();
    main.dispatchEvent(new Event('change', { bubbles: true }));
  }

  watch() {
    const target = document.querySelector('[data-bp-add], .product-form__submit, button[name="add"], [type="submit"][name="add"]');
    if (target && 'IntersectionObserver' in window) {
      this.io = new IntersectionObserver(
        (entries) => {
          const e = entries[0];
          this.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        },
        { threshold: 0 }
      );
      this.io.observe(target);
      return;
    }
    const onScroll = () => this.classList.toggle('is-visible', window.scrollY > 700);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  disconnectedCallback() {
    if (this.io) this.io.disconnect();
  }

  async add() {
    const picker = document.querySelector('bundle-picker [data-bp-add]');
    if (picker) {
      picker.click();
      return;
    }
        const mainField = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    const field = mainField || this.querySelector('.sab__vid');
    const id = field ? Number(field.value) : 0;
    if (!id) return;
    this.button.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(this.addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
      });
      if (!res.ok) throw new Error('add failed');
      window.location.href = this.afterAdd === 'checkout' ? '/checkout' : this.cartUrl;
    } catch (e) {
      this.button.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyAtc);
  } catch(e) { console.error(e); }
})();

})();
